import { Row, Col } from 'react-bootstrap';

export default function BuilderAppError({
    error,
}: {
    error?: Error | Record<string, string | undefined>;
}) {
    const { statusCode, stack, message }: Record<string, string | undefined> =
        error as unknown as Record<string, string | undefined>;

    return (
        <div className="d-flex align-items-center justify-content-center vh-100">
            <Row className="w-100">
                <Col md={{ span: 10, offset: 1 }}>
                    <h1 className="display-1 fw-bold">{statusCode ?? 500}</h1>
                    <p className="fs-3 text-danger">
                        {message ?? 'An unknown Error occured'}
                    </p>
                    {Boolean(stack) && (
                        <pre
                            style={{ whiteSpace: 'pre-wrap' }}
                            className="p-3 border bg-light text-secondary-emphasis"
                        >
                            {String(stack).trim()}
                        </pre>
                    )}
                </Col>
            </Row>
        </div>
    );
}
